const limits = ['auth', 'system', 'file', 'syslog']

const obj = window.__ERPAPPKEY__ || {}

const opt = Object.keys(obj).reduce((s, v) => {
  let writable = !limits.includes(v)
  s[v] = {
    configurable: writable,
    writable,
    enumerable: true,
    value: obj[v]
  }
  return s
}, {})

let _APPKEY

const NEW_APPKEY = Object.defineProperties({}, opt)

if (window.__ERP_PUBLIC_SHARED_APPKEY__) {
  _APPKEY = window.__ERP_PUBLIC_SHARED_APPKEY__
} else {
  window.__ERP_PUBLIC_SHARED_APPKEY__ = _APPKEY = NEW_APPKEY
}

export const APPKEY = _APPKEY



// WEBPACK FOOTER //
// ./src/public/config/appkey.js